import { useCallback } from "react"
import { useAxiosInstances } from "../axios-instance"
import {
    ILimitacaoConsumoCliente,
    ILimitacaoConsumoPerfil,
    ILimitacaoConsumoUsuario
} from "../../application/models"

export const useLimitacaoConsumoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const createLimitacaoConsumoClienteApi = useCallback(async (data: {
        IdCliente: number
        IdUsuario: number
        Quantidade: number
        IdProduto?: number | null
        IdTipoConsumo?: number[] | null
        isGrupo?: boolean
    }): Promise<void> => {
        try {
            await axiosAuthInstance.post('/limitacao-consumo-cliente/', {
                IdCliente: data.IdCliente,
                IdUsuario: data.IdUsuario,
                Quantidade: data.Quantidade,
                IdProduto: data.IdProduto,
                IdTipoConsumo: data.IdTipoConsumo,
                isGrupo: data.isGrupo
            })

            return
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const updateLimitacaoConsumoClienteApi = useCallback(async (data: {
        IdLimitacaoConsumoCliente: number
        IdCliente: number
        IdUsuario: number
        Ativo: boolean
        Quantidade: number
        IdGrupoTrava?: number
    }): Promise<void> => {
        try {
            await axiosAuthInstance.put(`/limitacao-consumo-cliente/${data.IdLimitacaoConsumoCliente}`, {
                Ativo: data.Ativo,
                Quantidade: data.Quantidade,
                IdCliente: data.IdCliente,
                IdUsuario: data.IdUsuario,
                IdGrupoTrava: data.IdGrupoTrava
            })

            return
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const findLimitacaoConsumoClienteApi = useCallback(async (data: {
        IdCliente: number
        IdUsuario: number
        Limit: number
        Page: number
    }): Promise<{
        LimitacaoConsumo: ILimitacaoConsumoCliente[]
        Total: number
    }> => {
        try {
            const result = await axiosAuthInstance.get(`/limitacao-consumo-cliente/cliente/${data.IdCliente}`, {
                params: {
                    Limit: data.Limit,
                    Page: data.Page,
                    IdUsuario: data.IdUsuario
                }
            })

            return {
                LimitacaoConsumo: result.data.LimitacaoConsumo,
                Total: result.data.Total
            }
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const createLimitacaoConsumoUsuarioApi = useCallback(async (data: {
        IdUsuario: number
        Quantidade: number
        IdProduto: number | null
        IdTipoConsumo: number[] | null
        IsGrupo: boolean
    }): Promise<void> => {
        try {
            await axiosAuthInstance.post('/limitacao-consumo-usuario/', {
                IdUsuario: data.IdUsuario,
                Quantidade: data.Quantidade,
                IdProduto: data.IdProduto,
                IdTipoConsumo: data.IdTipoConsumo,
                IsGrupo: data.IsGrupo
            })

            return
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const updateLimitacaoConsumoUsuarioApi = useCallback(async (data: {
        IdLimitacaoConsumoUsuario: number
        IdUsuario: number
        Ativo: boolean
        Quantidade: number
        IdGrupoTrava: number
    }): Promise<void> => {
        try {
            await axiosAuthInstance.put(`/limitacao-consumo-usuario/${data.IdLimitacaoConsumoUsuario || data.IdGrupoTrava}`, {
                IdUsuario: data.IdUsuario,
                Ativo: data.Ativo,
                Quantidade: data.Quantidade,
                IdGrupoTrava: data.IdGrupoTrava
            })

            return
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const findLimitacaoConsumoUsuarioApi = useCallback(async (data: {
        IdUsuario: number
        Limit: number
        Page: number
    }): Promise<{
        LimitacaoConsumo: ILimitacaoConsumoUsuario[]
        Total: number
    }> => {
        try {
            const result = await axiosAuthInstance.get(`/limitacao-consumo-usuario/usuario/${data.IdUsuario}`, {
                params: {
                    Limit: data.Limit,
                    Page: data.Page
                }
            })

            return {
                LimitacaoConsumo: result.data.LimitacaoConsumo,
                Total: result.data.Total
            }
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const createLimitacaoConsumoPerfilApi = useCallback(async (data: {
        IdPerfil: number
        IdUsuario: number
        Quantidade: number
        IdProduto: number | null
        IdTipoConsumo: number[] | null
        IsGrupo: boolean
    }): Promise<void> => {
        try {
            await axiosAuthInstance.post('/limitacao-consumo-perfil/', {
                IdPerfil: data.IdPerfil,
                IdUsuario: data.IdUsuario,
                Quantidade: data.Quantidade,
                IdProduto: data.IdProduto,
                IdTipoConsumo: data.IdTipoConsumo,
                IsGrupo: data.IsGrupo
            })
            return
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const updateLimitacaoConsumoPerfilApi = useCallback(async (data: {
        IdLimitacaoConsumoPerfil: number
        Quantidade: number
        Ativo: boolean
        IdUsuario: number
        IdPerfil: number
        IdGrupoTrava: number
    }): Promise<void> => {
        try {
            await axiosAuthInstance.put(`/limitacao-consumo-perfil/${data.IdLimitacaoConsumoPerfil || data.IdGrupoTrava}`, {
                Quantidade: data.Quantidade,
                Ativo: data.Ativo,
                IdUsuario: data.IdUsuario,
                IdPerfil: data.IdPerfil,
                IdGrupoTrava: data.IdGrupoTrava
            })
            return
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const findLimitacaoConsumoPerfilApi = useCallback(async (data: {
        IdPerfil: number
        Limit: number
        Page: number
    }): Promise<{
        LimitacaoConsumo: ILimitacaoConsumoPerfil[]
        Total: number
    }> => {
        try {
            const result = await axiosAuthInstance.get(`/limitacao-consumo-perfil/perfil/${data.IdPerfil}`, {
                params: {
                    Limit: data.Limit,
                    Page: data.Page
                }
            })

            return {
                LimitacaoConsumo: result.data.LimitacaoConsumo,
                Total: result.data.Total
            }

        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])


    return {
        createLimitacaoConsumoPerfilApi,
        updateLimitacaoConsumoPerfilApi,
        findLimitacaoConsumoPerfilApi,
        createLimitacaoConsumoClienteApi,
        updateLimitacaoConsumoClienteApi,
        findLimitacaoConsumoClienteApi,
        createLimitacaoConsumoUsuarioApi,
        updateLimitacaoConsumoUsuarioApi,
        findLimitacaoConsumoUsuarioApi
    }
}